export default __webpack_public_path__ + "media/zurb/img/icons/services/experience-cd277a4731d910b2a0a843bb3f89ab10.svg";